var map = {
	"./date-fns": "626b",
	"./date-fns.js": "626b",
	"./moment": "5be4",
	"./moment.js": "5be4",
	"./native": "7a50",
	"./native.js": "7a50",
	"./template": "a5d4",
	"./template.js": "a5d4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a6da";